angular.module('ui.login', [
    'ui.login.loginShadow'
])

    .config(function ($stateProvider, customTemplateResolverProvider) {
        $stateProvider.state('login', {
            url: '/login',
            template: customTemplateResolverProvider.get('login.html', 'app/ui/login/login.html'),
            controller: 'LoginController',
            data: {pageTitle: 'OrderManager: Login please'},
            resolve: {loadingWaiter: function(){
                //hack that will hide loading screen, when main state is ready
                if(window.omHideLoadingScreenCallback) {
                    window.omHideLoadingScreenCallback();
                }
            }}
        });
    })
    .directive("autofill", function () {
        return {
            require: "ngModel",
            link: function (scope, element, attrs, ngModel) {
                scope.$on("autofill:update", function () {
                    ngModel.$setViewValue(element.val());
                });
            }
        }
    })

    .controller('LoginController', function LoginController($scope, $state, $localStorage, $timeout, authService, toastr, gettextCatalog) {
        $scope.isBusy = false;
        $scope.credentials = {};
        $scope.isPwdResetRequested = false;
        $scope.pwdResetRequestUser = null;
        $scope.pwdResetRequestSuccess = false;
        $scope.pwdResetLabel = gettextCatalog.getString("Reset your password");

        $scope.login = function () {
            $scope.isBusy = true;
            $scope.$broadcast("autofill:update");

            authService.login($scope.credentials.login, $scope.credentials.password)
                .then(
                function () {
                    $state.go('client.home');// redirect user to his home page
                },
                function (resp) {
                    var data = resp.data;
                    var msg;
                    if (data && data.error && _.isString(data.error)) {
                        msg = data.error;
                    } else if (data && _.isString(data) && data.length > 0 && data.length < 256) {
                        msg = data;
                    } else {
                        msg = gettextCatalog.getString("Wrong username or password. Please try again.");
                    }
                    toastr.error(msg, gettextCatalog.getString("Login failed"));
                    $scope.isBusy = false;
                });

            return false;
        };

        $scope.requestPwdReset = function () {

            if (!$scope.userNameEmailValidator.validate())
                return false;

            $scope.pwdResetLabel = gettextCatalog.getString("Requesting password reset...");
            $scope.isBusy = true;
            
            authService.requestPasswordReset($scope.pwdResetRequestUser)
                .then(
                    function () {
                        $scope.pwdResetLabel = gettextCatalog.getString("Password Reset Key has been sent to your registered Email Address.");
                        $scope.pwdResetRequestSuccess = true;
                        $scope.isBusy = false;
                    },
                    function (resp) {
                        var data = resp.data;
                        var msg;
                        if (data && data.error && _.isString(data.error)) {
                            msg = data.error;
                        } else if (data && _.isString(data) && data.length > 0 && data.length < 256) {
                            msg = data;
                        } else {
                            msg = gettextCatalog.getString("Request to reset password failed due to an error");
                        }
                        toastr.error(msg, gettextCatalog.getString("Request failed"));
                        $scope.isBusy = false;
                        $scope.pwdResetRequestSuccess = false;
                    });

            return false;
        };
    })

;